import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faPlay } from '@fortawesome/free-solid-svg-icons';
import AboutImage from '../../assets/itech1.jpg';
import data from './data';
import Card, { CardIcon, CardBody, CardTitle, CardDescription } from '../../components/Card';
import './about.css';

const About = () => {
  const handleLearnMoreClick = () => {
    const portfolioSection = document.getElementById('portfolio');
    if (portfolioSection) {
      portfolioSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="about section section--surface" id="about">
      <div className="container">
        <div className="about__container">
          {/* About Content */}
          <div className="about__content">
            {/* Badge */}
            <div className="about__badge" data-aos="fade-up">
              <FontAwesomeIcon icon={faCheckCircle} className="about__badge-icon" />
              <span>Layanan Apple Terpercaya</span>
            </div>

            {/* Main Title */}
            <h2 className="about__title" data-aos="fade-up" data-aos-delay="100">
              Mengapa Memilih 
              <span className="about__title-highlight"> iTech Service?</span>
            </h2>

            {/* Description */}
            <p className="about__description" data-aos="fade-up" data-aos-delay="200">
            iTech Service hadir sebagai solusi profesional untuk perbaikan dan perawatan perangkat Apple. Mulai dari kerusakan hardware hingga kendala software, kami memberikan layanan cepat, aman, dan berkualitas dengan penanganan teknisi berpengalaman.
            </p>

            {/* Features Grid */}
            <div className="about__features" data-aos="fade-up" data-aos-delay="300">
              {data.map((feature, index) => (
                <Card 
                  key={feature.id} 
                  variant="minimal"
                  interactive={false}
                  className="about__feature-card"
                  data-aos="fade-up"
                  data-aos-delay={400 + (index * 100)}
                >
                  <CardIcon 
                    variant="light" 
                    className="about__feature-icon"
                  >
                    {feature.icon}
                  </CardIcon>
                  
                  <CardBody className="about__feature-content">
                    <CardTitle className="about__feature-title">
                      {feature.title}
                    </CardTitle>
                    
                    <CardDescription className="about__feature-description">
                      {feature.desc}
                    </CardDescription>
                  </CardBody>
                </Card>
              ))}
            </div>

            {/* Company Info */}
            <div className="about__company-info" data-aos="fade-up" data-aos-delay="600">
              <h3 className="about__company-title">iTech Service</h3>
              <p className="about__company-description">
              Dengan dukungan teknisi berpengalaman dan standar pengerjaan yang profesional, iTech Service berkomitmen memberikan pengalaman servis Apple yang aman, nyaman, dan berkualitas.
              </p>
            </div>

            {false && (
  <div className="about__actions" data-aos="fade-up" data-aos-delay="700">
    <button 
      className="btn btn-primary about__cta-primary"
      onClick={() => {
        const contactSection = document.getElementById('contact');
        if (contactSection) {
          contactSection.scrollIntoView({ behavior: 'smooth' });
        }
      }}
      aria-label="Hubungi kami untuk konsultasi"
    >
      <FontAwesomeIcon icon={faCheckCircle} />
      <span>Konsultasi Gratis</span>
    </button>
    
    <button 
      className="btn btn-secondary about__cta-secondary"
      onClick={handleLearnMoreClick}
      aria-label="Lihat portfolio kami"
    >
      <FontAwesomeIcon icon={faPlay} />
      <span>Kunjungi Kami</span>
    </button>
  </div>
)}
          </div>

          {/* About Image */}
          <div className="about__image-container">
            <div className="about__image-wrapper" data-aos="fade-left" data-aos-delay="300">
              <img 
                src={AboutImage} 
                alt="Layanan reparasi perangkat Apple profesional di iTech Service" 
                className="about__image"
                loading="lazy"
              />
              
              {/* Image Overlays */}
              <div className="about__image-overlay">
                <div className="about__image-badge">
                  <div className="about__badge-content">
                    <span className="about__badge-number">1000+</span>
                    <span className="about__badge-text">Perangkat Diperbaiki</span>
                  </div>
                </div>
              </div>

              {/* Trust Indicators */}
              <div className="about__trust-indicators">
                <div className="about__trust-item" data-aos="fade-up" data-aos-delay="800">
                  <FontAwesomeIcon icon={faCheckCircle} className="about__trust-icon" />
                  <span className="about__trust-text">Garansi 24 Bulan</span>
                </div>
                
                <div className="about__trust-item" data-aos="fade-up" data-aos-delay="900">
                  <FontAwesomeIcon icon={faCheckCircle} className="about__trust-icon" />
                  <span className="about__trust-text">Hanya Suku Cadang Asli</span>
                </div>
                
                <div className="about__trust-item" data-aos="fade-up" data-aos-delay="1000">
                  <FontAwesomeIcon icon={faCheckCircle} className="about__trust-icon" />
                  <span className="about__trust-text">Teknisi Ahli</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
